import React from 'react';
import '../scss/PromotionBadge.scss';

const PromotionBadge = ({ promotion, onClick }) => {
  if (!promotion) return null;

  const { type, amount4Tyres, url } = promotion;
  const suffix = type === 'ODR' ? 'Remboursés' : 'En bon d\'achat';

  const handleClick = (e) => {
    if (url) {
      e.preventDefault();
      e.stopPropagation();
      window.open(url, '_blank');
    }
  };

  return (
    <div 
      className={`promotion-badge ${url ? 'clickable' : ''}`}
      onClick={handleClick}
      title={url ? 'Cliquer pour plus d\'informations' : undefined}
    >
      <div className="promotion-amount">Jusqu'à {amount4Tyres}€</div>
      <div className="promotion-type">{suffix}</div>
    </div>
  );
};

export default PromotionBadge; 